
import React, { useState } from 'react';
import './EmailPage.css';
import PageHeader from '../../components/shared/PageHeader';
import Badge from '../../components/shared/Badge';
import Button from '../../components/shared/Button';

const EMAILS = [
  { id: 1, from: 'Sarah Mitchell', subject: 'Q1 Proposal Review', preview: 'Hi, I wanted to follow up on the proposal we discussed…', time: '10:42 AM', unread: true, starred: true },
  { id: 2, from: 'James Reeves', subject: 'Invoice INV-0048', preview: 'Please find attached the invoice for this month…', time: '9:15 AM', unread: true, starred: false },
  { id: 3, from: 'Support Team', subject: 'Your ticket #8842 was resolved', preview: 'We have resolved your support ticket regarding…', time: 'Yesterday', unread: false, starred: false },
  { id: 4, from: 'Elena Vasquez', subject: 'Partnership Opportunity', preview: 'I hope this message finds you well. I am reaching out…', time: 'Feb 20', unread: false, starred: true },
  { id: 5, from: 'GitHub Notifications', subject: 'New PR: feat/ai-hub-streaming', preview: '[super-dashboard] PR #42 opened by devteam…', time: 'Feb 19', unread: false, starred: false },
];

export default function EmailPage() {
  const [selected, setSelected] = useState(EMAILS[0]);
  const [compose, setCompose] = useState(false);

  return (
    <div className="email-page">
      <PageHeader title="Inbox" breadcrumb={['Business', 'Inbox']} actions={<Button icon="✏" size="sm" onClick={() => setCompose(true)}>Compose</Button>} />
      <div className="email-layout">
        <div className="email-sidebar">
          <div className="email-folders">
            {[['Inbox','📥',3],['Starred','⭐',0],['Sent','📤',0],['Drafts','📝',1],['Trash','🗑',0]].map(([label, icon, count]) => (
              <button key={label as string} className="email-folder">
                <span>{icon}</span>
                <span className="email-folder__label">{label}</span>
                {(count as number) > 0 && <Badge variant="ocean">{count as number}</Badge>}
              </button>
            ))}
          </div>
        </div>
        <div className="email-list">
          {EMAILS.map(e => (
            <button key={e.id} className={`email-item${selected?.id === e.id ? ' email-item--selected' : ''}${e.unread ? ' email-item--unread' : ''}`} onClick={() => setSelected(e)}>
              <div className="email-avatar">{e.from[0]}</div>
              <div className="email-meta">
                <div className="email-from-row">
                  <span className="email-from">{e.from}</span>
                  <span className="email-time">{e.time}</span>
                </div>
                <div className="email-subject">{e.subject}</div>
                <div className="email-preview">{e.preview}</div>
              </div>
              {e.starred && <span className="email-star">⭐</span>}
            </button>
          ))}
        </div>
        <div className="email-reader">
          {selected ? (
            <>
              <div className="email-reader__header">
                <h2 className="email-reader__subject">{selected.subject}</h2>
                <div className="email-reader__from">
                  <div className="email-avatar">{selected.from[0]}</div>
                  <div><strong>{selected.from}</strong><span className="email-reader__time"> · {selected.time}</span></div>
                </div>
              </div>
              <div className="email-reader__body">
                <p>Hi,</p>
                <p>Thank you for reaching out. I wanted to follow up regarding {selected.subject.toLowerCase()}. We have reviewed everything and believe we are aligned on the next steps.</p>
                <p>Please let me know if you have any questions or need additional details. Looking forward to your response.</p>
                <p>Best regards,<br />{selected.from}</p>
              </div>
              <div className="email-reader__actions">
                <Button icon="↩" variant="ghost" size="sm">Reply</Button>
                <Button icon="↪" variant="ghost" size="sm">Forward</Button>
                <Button icon="🗑" variant="ghost" size="sm">Delete</Button>
              </div>
            </>
          ) : (
            <div className="email-empty">Select an email to read</div>
          )}
        </div>
      </div>
      {compose && (
        <div className="compose-overlay" onClick={() => setCompose(false)}>
          <div className="compose-window" onClick={e => e.stopPropagation()}>
            <div className="compose-header"><span>New Message</span><button className="modal__close" onClick={() => setCompose(false)}>✕</button></div>
            <div className="compose-body">
              <input className="compose-field" placeholder="To:" />
              <input className="compose-field" placeholder="Subject:" />
              <textarea className="compose-textarea" placeholder="Write your message…" />
            </div>
            <div className="compose-footer">
              <Button size="sm">Send</Button>
              <Button variant="ghost" size="sm" onClick={() => setCompose(false)}>Discard</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
